import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReactMarkdown from "react-markdown";


// FAQ Data
const helpData = {
  Registration: [
    {
      question: "How do I create an account in TA Wallet?",
      answer: `An account, called TA Wallet a/c, is created after successful registration of the user with TA Wallet System.

To register with TA Wallet, Please follow one of the following methods.

**Method 1 – Using Mobile App (Android/iOS)**  
Download and install the TA Wallet App from Google Play Store (for Android Phone), Apple App Store(for iPhone) In the Login Page, click on “Register” button and fill the details. One can register using mobile number.

**Method 2 – Using Web Application (Desktop / Laptop)**  
- Visit the URL: https://www.tawallet.com  
- Click on “Register” button and fill the details. Registration is possible using mobile number.`,
    },
    {
      question: "How to login?",
      answer: `**Method 1 – Using Mobile App**  
- After registration is successfully completed, you will see the login page where you have to enter mobile number and password.  
- Tap on the "Login" button to log in securely.  

**Method 2 – Using Web Application (Desktop / Laptop)**  
- After registration is successfully completed, go to the login page and enter mobile number and password.  
- Enter CAPTCHA code and click on "Login" button to log in securely.  

**If Account is Blocked?**  
- Please contact us. We are here to help you.`,
    },
    {
      question: "Any registration fee for using TA Wallet?",
      answer: "No, there is no registration fee for using TA Wallet.",
    },
    {
      question: "Types of TA Wallet account & how to open?",
      answer: `There are 2 types of TA Wallet accounts:

**Low KYC (Small PPI)**  
- Source: Mobile / Web Application 
- Verification: OTP to Mobile number  

**Full KYC**  
- Source: Mobile / Web Application   
- Verification: Video KYC (Aadhaar Number, PAN Number)


Users can apply online for upgrade through TA Wallet app.`,
    },
    {
      question: "How long can I hold the Low KYC Wallet?",
      answer: `You can have LOW KYC Wallet forever, if it is not expired. For details of wallet expiration, Please refer to  "TYPES OF WALLET AND GENERAL CONDITIONS" Section in  "Terms & Conditions".
- You can always convert Low KYC wallet into Full KYC wallet at any time.  
- A wallet account is treated as EXPIRED after 12 months of inactivity.  
- Wallets not operated for more than 12 months will be made inactive.`,
    },
    {
      question: "What is cooling period?",
      answer: `Please refer to "COOLING PERIODS" Section in "Terms & Conditions":
`,
    },
  ],
};

const Registration = ({ selectedSection = "Registration" }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box>
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 260 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Box
          component="img"
          src="/Assets/Registratrion.jpg"
          alt="Registration Banner"
          sx={{
            width: "100%",
            maxWidth: 950,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 12px 12px",
          }}
        />
      </Box>

      {/* FAQ Title */}
      <Box mt={4} textAlign="center" px={2}>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Your Profile
        </Typography>
        {/* Optional Subtitle */}
        {/* <Typography variant="body2" color="text.secondary">
          Learn how to register and use your TA Wallet account.
        </Typography> */}
      </Box>

      {/* FAQ List */}
      <Box maxWidth="900px" mx="auto" px={2} py={4}>
        <List disablePadding>
          {helpData[selectedSection]?.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  px: 2,
                  py: 1.5,
                  borderBottom: "1px solid #eee",
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Typography fontWeight="medium">{item.question}</Typography>
                  }
                />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <ReactMarkdown>{item.answer}</ReactMarkdown>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Registration;
